// extracted by mini-css-extract-plugin
module.exports = {"container":"_2SMZ7DNQDxLWqk9PGrwV_g","visible":"h7L2eizOV-SklL6p4EUkl","cancelBtn":"zg7DzBAr6Mp8IguUIvMnv","icon":"_2pgjghoZSx2YihnAOrbCFA","saveBtn":"_1XrXxM4U7DxnHSQNFwa60w"};